import type { SVGProps } from 'react'
const UserEditIconIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 40 40" {...props}>
    <path
      fill="#2852E4"
      d="M33.864 22.718a3.89 3.89 0 0 1 0 5.501l-5.318 5.318c-.357.357-.82.589-1.32.66l-3.592.514a1.557 1.557 0 0 1-1.762-1.763l.513-3.592c.071-.5.303-.963.66-1.32l5.318-5.318a3.89 3.89 0 0 1 5.501 0"
    />
    <foreignObject width={44.337} height={53.659} x={-6.276} y={-7.276}>
      <div
        style={{
          backdropFilter: 'blur(5.64px)',
          clipPath: 'url(#User_edit_icon_svg__a)',
          height: '100%',
          width: '100%'
        }}
      />
    </foreignObject>
    <path
      fill="url(#User_edit_icon_svg__b)"
      fillOpacity={0.3}
      d="M19.005 4a7.78 7.78 0 1 0 0 15.56 7.78 7.78 0 0 0 0-15.56m0 17.117a19 19 0 0 1 2.683.186 1.556 1.556 0 0 1 .838 2.687 10.86 10.86 0 0 0-3.521 8.02q0 .686.082 1.35a1.556 1.556 0 0 1-1.575 1.747c-3.129-.063-6.052-.336-8.238-1.006-1.092-.334-2.122-.803-2.903-1.496C5.546 31.875 5 30.887 5 29.675c0-1.225.557-2.37 1.313-3.328.769-.973 1.832-1.869 3.079-2.63 2.493-1.52 5.885-2.6 9.613-2.6"
      data-figma-bg-blur-radius={11.276}
    />
    <defs>
      <linearGradient
        id="User_edit_icon_svg__b"
        x1={7.331}
        x2={33.684}
        y1={6.87}
        y2={16.426}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5A81FF" stopOpacity={0.9} />
        <stop offset={0.447} stopColor="#567DFF" stopOpacity={0.955} />
        <stop offset={1} stopColor="#4E78FF" stopOpacity={0.9} />
      </linearGradient>
      <clipPath id="User_edit_icon_svg__a">
        <path d="M25.28 11.276a7.78 7.78 0 1 0 0 15.56 7.78 7.78 0 0 0 0-15.56m0 17.117a19 19 0 0 1 2.683.186 1.556 1.556 0 0 1 .838 2.687 10.86 10.86 0 0 0-3.52 8.019q0 .688.082 1.351a1.556 1.556 0 0 1-1.575 1.747c-3.129-.063-6.052-.336-8.238-1.006-1.092-.334-2.122-.803-2.903-1.496-.825-.73-1.371-1.718-1.371-2.93 0-1.225.557-2.37 1.313-3.328.769-.973 1.832-1.869 3.078-2.63 2.494-1.521 5.886-2.6 9.613-2.6" />
      </clipPath>
    </defs>
  </svg>
)
export default UserEditIconIcon
